import { StudioApiDataPackageProvider } from '@gametailors/lp-studio-connector';

export const STUDIO_API_DATA_PACKAGE_PROVIDER = new StudioApiDataPackageProvider(
  'https://api.woordkr8.dev.gametailors.com/cas',
  's_HIrKbAeWf3NTpS2mtxIi3',
  'dp_K9vSr8C4cpTcqu2NpY9Xd',
  {
    url: 'https://api.woordkr8.dev.gametailors.com/auth',
    username: 'woordkr8-service',
    password: 'MKk1kYpp4xb0FLyEJ8uzprMw',
  },
);
